import React from 'react';
import { QuestionnaireItem } from '../QuestionnairePreview';
// @ts-ignore
import styles from './../QuestionnairePreview.module.scss';
import QuestionnairePreviewItems from '../QuestionnairePreviewItems';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	item: QuestionnaireItem;
}

const QuestionnairePreviewQuestion: React.FC<Props> = ({ item }) => {
	const { t } = useTranslation();

	return (
		<>
			<div className={styles.title}>{item.title}</div>
			{item.title2 && (
				<div className={styles.title2}>
					{t('component.questionnairePreview.subtitle')}: {item.title2}
				</div>
			)}
			<QuestionnairePreviewItems children={item.children} />
		</>
	);
};

export default QuestionnairePreviewQuestion;
